/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetRoleInput
 */
export interface SetRoleInput {
    /**
     * 
     * @type {string}
     * @memberof SetRoleInput
     */
    roleId?: string | null;
}

/**
 * Check if a given object implements the SetRoleInput interface.
 */
export function instanceOfSetRoleInput(value: object): value is SetRoleInput {
    return true;
}

export function SetRoleInputFromJSON(json: any): SetRoleInput {
    return SetRoleInputFromJSONTyped(json, false);
}

export function SetRoleInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetRoleInput {
    if (json == null) {
        return json;
    }
    return {
        
        'roleId': json['roleId'] == null ? undefined : json['roleId'],
    };
}

export function SetRoleInputToJSON(json: any): SetRoleInput {
    return SetRoleInputToJSONTyped(json, false);
}

export function SetRoleInputToJSONTyped(value?: SetRoleInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleId': value['roleId'],
    };
}

